import { createAsyncThunk } from '@reduxjs/toolkit';
import { getApiResult, getEmittedResult, isSocketConnected } from 'store/exchange/utils/communicationUtills';
import { errorCatcher } from 'store/exchange/utils/errorCatcher';
import { makeObjToUrlQuery } from 'store/exchange/utils/makeObjToUrlQuery';

export const getCandleStickData = createAsyncThunk('chart/getCandleStickData', async (payload, { getState }) => {
  try {
    let result;
    if (isSocketConnected(getState)) {
      result = await getEmittedResult('dexGetCandlestickByPair', payload);
    } else {
      const urlQuery = makeObjToUrlQuery(payload);
      result = await getApiResult(`chart/candlestick${urlQuery}`, 'get');
    }
    return result;
  } catch (e) {
    throw errorCatcher(e);
  }
});
